import { TenderTimeProvider } from "../../../context/TenderTimeProvider";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import style from "./common.module.scss";
import { File, MapsData, Order, User } from "../../../services";
import OrdersInfoCargo from "./components/OrdersInfoCargo";
import OrdersInfoHeader from "./components/OrdersInfoHeader";
import OrdersInfoBasic from "./components/OrdersInfoBasic";
import OrdersInfoDirections from "./components/OrdersInfoDirections";
import OrdersDriverInfo from "./components/OrdersDriverInfo";
import InfoIcon from "../../shared/icons/InfoIcon";
import Loading from "../../shared/Loading/Loading";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import OrdersInfoAddressList from "./components/OrdersInfoAddressList";
import OrderBookingStatus from "./components/OrderBookingStatus"; // Import the new component
import OrderHistoryMobile from "./components/mobile/OrderHistoryMobile";
import { useNavigate, useParams } from "react-router-dom";
import UploadFile from "./components/UploadFile";
import OrdersChatHub from "../../shared/chat/OrdersChatHub";
import InsuranceStatus from "./components/InsuranceStatus/InsuranceStatus";
import { useLanguage } from "../../../context/LanguageContext";
import OrderInfoMobileActions from "./components/mobile/OrderInfoMobileActions";

const OrderInfoMobile = () => {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();
  const { user } = useSelector((state) => state);
  const company = useSelector((state) => state.user.company);
  const params = useParams();
  const navigate = useNavigate();

  const orderId = params.id;

  const [getOrder, setOrder] = useState(null);
  const [cargoDetails, setCargoDetails] = useState();
  const [recipient, setRecipient] = useState();
  const [bookingDate, setBookingDate] = useState();
  const [statusHistory, setStatusHistory] = useState();
  const [cityFrom, setCityFrom] = useState();
  const [cityTo, setCityTo] = useState();
  const [routeData, setRouteData] = useState(null);
  const [routeStartCity, setRouteStartCity] = useState(null);
  const [coordinate, setCoordinate] = useState([]);
  const [listDocDriver, setListDocDriver] = useState([]);
  const [driverPhotos, setDriverPhotos] = useState([]);
  const [listSuggestedPrice, setListSuggestedPrice] = useState([]);
  const [complexTenderPrices, setComplexTenderPrices] = useState([]);
  const [driverPrices, setDriverPrices] = useState([]);
  const [complexTenderBids, setComplexTenderBids] = useState([]);
  const [orderViews, setOrderViews] = useState([]);
  const [listFilesOrder, setListFilesOrder] = useState([]);
  const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);
  const allowedStatusesForDocs = [
    'assigned',
    'assignedexecutor',
    'confirmed',
    'headingtoloading',
    'processloadingcargo',
    'onthetrip',
    'processunloadingcargo',
    'unloadingcargomoderation',
    'completedbyexecutor',
  ];

  const [isLoading, setLoading] = useState(false);
  const [isLoadingMap, setIsLoadingMap] = useState(false);
  const [isOpenModalHistory, setIsOpenModalHistory] = useState(false);
  const [isOpenChatModal, setIsOpenChatModal] = useState(false);

  const onForceUpdate = () => {
    fetchOrderData();
  };

  const fetchOrderData = async () => {
    setLoading(true);
    if (orderId) {
      try {
        const { data } = await Order.getOrderById(orderId, currentLanguage);
        if (data.shippingDate) {
          let date = data.shippingDate.split("T");
          const timeStart =
            data.shippingHourFrom < 10
              ? `0${data.shippingHourFrom}`
              : data.shippingHourFrom;
          const timeEnd =
            data.shippingHourTo < 10 ? `0${data.shippingHourTo}` : data.shippingHourTo;
          data.shippingDate = `${date[0]}T${timeStart}:00:00`;
          data.shippingDateEnd = `${date[0]}T${timeEnd}:00:00`;
        }
        if (data.unloadingDate) {
          let date = data.unloadingDate.split("T");
          const timeStart =
            data.unloadingHourFrom < 10
              ? `0${data.unloadingHourFrom}`
              : data.unloadingHourFrom;
          const timeEnd =
            data.unloadingHourTo < 10 ? `0${data.unloadingHourTo}` : data.unloadingHourTo;
          data.unloadingDate = `${date[0]}T${timeStart}:00:00`;
          data.unloadingDateEnd = `${date[0]}T${timeEnd}:00:00`;
        }
        setOrder(data);
        console.log("[DATA]", data);
      } catch (e) {
        console.log(e);
        toast.error(t('orderInfo.genericError'));
      } finally {
        setLoading(false);
      }
    }
  };

  const fetchDocuments = () => {
    if (!getOrder?.id) return;
    Promise.all([
      File.getFilesByOrder(getOrder.id, 5),
      File.getFilesByOrder(getOrder.id, 7)
    ])
      .then(([resp5, resp7]) => {
        const merged = [
          ...(resp5?.data || []),
          ...(resp7?.data || [])
        ].reverse();
        setListFilesOrder(merged);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    setIsLoadingMap(true);
    setRouteData(null);
    setListSuggestedPrice([]);
    setComplexTenderPrices([]);
    setDriverPrices([]);
    setComplexTenderBids([]);
    setOrderViews([]);

    if (getOrder) {
      const addressList = getOrder.addressList || [];
      const addressListLength = addressList.length || 0;

      if (addressListLength === 2) {
        const loadingAddress = addressList.find(addr => addr.type === 'Loading');
        const unloadingAddress = addressList.find(addr => addr.type === 'Unloading');

        const hasUserAddressIds =
          loadingAddress?.latLng && unloadingAddress?.latLng;

        const routeMethod = hasUserAddressIds
          ? 'getRouteByAddressId'
          : 'getRoute';

        const args = hasUserAddressIds
          ? [loadingAddress.userAddressId, unloadingAddress.userAddressId]
          : [getOrder.cityIdFrom, getOrder.cityIdTo];

        setIsLoadingMap(true);

        MapsData[routeMethod](...args)
          .then((response) => {
            try {
              if (!response?.data?.jsonData) throw new Error('Нет jsonData');
              let parsedData = JSON.parse(response.data.jsonData);

              if (response.data.fromCityId !== getOrder.cityIdFrom) {
                parsedData = parsedData.reverse();
              }

              setRouteStartCity(response.data.fromCityId);
              setRouteData(parsedData);
            } catch (error) {
              console.error('Ошибка при парсинге JSON:', error);
              setRouteData(null);
            } finally {
              setIsLoadingMap(false);
            }
          })
          .catch((error) => {
            console.error(error);
            setIsLoadingMap(false);
            toast.error(t('orderInfo.genericError'));
          });
      } else if (addressListLength > 2) {
        setRouteData(null);
        setIsLoadingMap(false);
      }

      Order.getCargo(getOrder.cargoId)
        .then((response) => {
          if (response.status == 200) {
            setCargoDetails(response.data);
          } else {
            setCargoDetails({});
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error(t('orderInfo.genericError'));
        });

      Order.getRecipient(getOrder.recipientId)
        .then((response) => {
          if (response.status == 200) {
            setRecipient(response.data);
          } else {
            setRecipient({});
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error(t('orderInfo.genericError'));
        });

      User.getHistory(orderId)
        .then((res) => res.data)
        .then((data) => {
          setBookingDate(data[3]?.createdAt);
          setStatusHistory(data);
        })
        .catch((error) => {
          console.log(error);
          toast.error(t('orderInfo.genericError'));
        });

      Order.getCityById(getOrder.cityIdFrom)
        .then((response) => {
          if (response.status == 200) {
            setCityFrom(response.data);
          } else {
            setCityFrom(null);
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error(t('orderInfo.genericError'));
        });

      Order.getCityById(getOrder.cityIdTo)
        .then((response) => {
          if (response.status == 200) {
            setCityTo(response.data);
          } else {
            setCityTo(null);
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error(t('orderInfo.genericError'));
        });

      Order.getUnreadMessages(getOrder.id)
        .then((response) => {
          if (response.status === 200) {
            setUnreadMessagesCount(response.data?.count || 0);
          }
        })
        .catch((error) => {
          console.log(error);
        });

      User.getCoordinate(getOrder.number)
        .then((response) => {
          if (response.status == 200) {
            const post = [];
            if (response.data && response.data.length) {
              response.data.map((m) => {
                post.push({
                  lat: m.latitude,
                  lng: m.longitude,
                  date: m.createdAtStr,
                  type: m.type,
                });
              });
            }
            setCoordinate(post);
          }
        })
        .catch((error) => {
          console.log(error);
        });

      if (getOrder && getOrder.driverId) {
        File.getDocList(getOrder.driverId)
          .then((response) => {
            const filteredData = response.data.filter((doc) => doc.type !== 8);
            const hasTypes = [4, 5, 7].some((type) =>
              filteredData.some((doc) => doc.type === type),
            );

            setListDocDriver(filteredData);

            if (!hasTypes && getOrder.vehicleId) {
              File.getDocListVehicle(getOrder.vehicleId)
                .then((vehicleResponse) => {
                  const combinedData = [...filteredData, ...vehicleResponse.data];
                  setListDocDriver(combinedData);
                })
                .catch((error) => {
                  console.log("Ошибка при получении документов ТС:", error);
                });
            }
          })
          .catch((error) => {
            console.log("Ошибка при получении документов водителя:", error);
          });
      } else if (getOrder && getOrder.vehicleId) {
        File.getDocListVehicle(getOrder.vehicleId)
          .then((vehicleResponse) => {
            setListDocDriver(vehicleResponse.data);
          })
          .catch((error) => {
            console.log("Ошибка при получении документов ТС:", error);
          });
      } else {
        console.log("Невозможно получить документы: ID водителя и ТС не определены");
        setListDocDriver([]);
      }

      File.getOrderDocsDriverPhotos(getOrder.id)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            setDriverPhotos(response.data);
          }
        })
        .catch((error) => {
          console.log("error order docs", error);
        });

      Promise.all([
        File.getFilesByOrder(getOrder.id, 5),
        File.getFilesByOrder(getOrder.id, 7)
      ])
        .then(([resp5, resp7]) => {
          const merged = [
            ...(resp5?.data || []),
            ...(resp7?.data || [])
          ].reverse();
          setListFilesOrder(merged);
        })
        .catch((error) => {
          console.log(error);
          toast.error(t('orderInfo.genericError'));
        });

      if (user.type === "Client" || getOrder.companyId === company.id) {
        if (getOrder.isComplexTender) {
          Order.getComplexOrderBidList(getOrder.id)
            .then((response) => setComplexTenderBids(response?.data || []))
            .catch((error) => {
              console.log(error);
            });
        } else {
          Order.getListSuggestedPrice(getOrder.id)
            .then((response) => {
              const allPrices = response?.data?.rows || [];
              const drivers = allPrices.filter((item) => item.userType === "driver");
              const nonDriverPrices = allPrices.filter((item) => item.userType !== "driver");

              setListSuggestedPrice(nonDriverPrices);
              setComplexTenderPrices(
                nonDriverPrices.filter((item) => Boolean(item.vehiclesCount)),
              );
              setDriverPrices(drivers);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }

      if (user.companyId === company.id) {
        Order.getOrderViewById(getOrder.id)
          .then((response) => {
            if (response.status === 200) {
              setOrderViews(response.data);
            } else {
              setOrderViews([]);
            }
          })
          .catch((error) => {
            console.log(error);
            setOrderViews([]);
          });
      }

      if (user.companyId !== company.id) {
        Order.createOrderView(getOrder.id)
          .then(() => {})
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }, [getOrder]);

  useEffect(() => {
    setUnreadMessagesCount(0);
    fetchOrderData();
  }, [orderId]);

  return (
    <TenderTimeProvider sessionKey={JSON.stringify([orderId, user?.companyId ?? user?.company?.id])}>
    <div className={cn(style.wrapper_mobile)}>
      <OrdersInfoHeader
        item={getOrder}
        onForceUpdate={onForceUpdate}
        orderViews={orderViews}
      />
      {isLoading ? <Loading borderRadius="16px" /> : null}
      <div className={style.orders_content}>
        <OrdersInfoBasic
          item={getOrder}
          onOpen={() => setIsOpenModalHistory(true)}
          onOpenChat={() => setIsOpenChatModal(true)}
          unreadCount={unreadMessagesCount}
        />
        {isOpenModalHistory && (
          <OrderHistoryMobile
            item={getOrder}
            isOpen={isOpenModalHistory}
            statusHistory={statusHistory}
            onClose={() => setIsOpenModalHistory(false)}
            senderName={getOrder?.senderName}
            recipientName={recipient?.name}
            cargoDetails={cargoDetails}
            cityFrom={cityFrom}
            cityTo={cityTo}
            routeData={routeData}
            isLoadingMap={isLoadingMap}
            routeStartCity={routeStartCity}
            coordinateTruck={coordinate}
            bookingDate={bookingDate}
            driverPhotos={driverPhotos}
            listDocDriver={listDocDriver}
            listFilesOrder={listFilesOrder}
            refreshDocuments={fetchDocuments}
          />
        )}

        {isOpenChatModal && getOrder && (
          <OrdersChatHub
            isOpen={isOpenChatModal}
            orderData={getOrder}
            orderId={getOrder?.id}
            orderNumber={getOrder.number}
            onClose={() => setIsOpenChatModal(false)}
          />
        )}

        {getOrder && user.type === "Client" && (
          <OrderBookingStatus
            order={getOrder}
            user={user}
            onUpdateData={onForceUpdate}
            fetchOrderData={fetchOrderData}
          />
        )}

        {getOrder && user.type === "Expeditor" && getOrder.companyId === company.id && (
          <OrderBookingStatus
            order={getOrder}
            user={user}
            onUpdateData={onForceUpdate}
            fetchOrderData={fetchOrderData}
          />
        )}

        {getOrder && getOrder.addressList.length < 1 ? (
          <OrdersInfoDirections
            item={getOrder}
            senderName={getOrder?.senderName}
            recipientName={recipient?.name}
          />
        ) : (
          <OrdersInfoAddressList
            order={getOrder}
            addressList={getOrder?.addressList}
          />
        )}

        <OrderInfoMobileActions
          order={getOrder}
          cargoDetails={cargoDetails}
          statusHistory={statusHistory}
          fetchOrderData={fetchOrderData}
          onForceUpdate={onForceUpdate}
          refreshDocuments={fetchDocuments}
          onClose={() => navigate(-1)}
          user={user}
          company={company}
          listSuggestedPrice={listSuggestedPrice}
          complexTenderPrices={complexTenderPrices}
          driverPrices={driverPrices}
          complexTenderBids={complexTenderBids}
        />

        {getOrder && user?.type !== "Client" && getOrder.insuranceIncluded && (
          <InsuranceStatus orderId={getOrder.id} userType={user.type.toLowerCase()} />
        )}

        {getOrder && (getOrder.drivers?.length > 0 || getOrder.driverId) && (
          <OrdersDriverInfo
            item={getOrder}
            drivers={getOrder.drivers || []}
            driverId={getOrder.driverId}
            recipientName={recipient?.name}
            senderName={getOrder?.senderName}
            bookingDate={bookingDate}
            listDocDriver={listDocDriver}
          />
        )}
        {getOrder &&
          user?.type === "Client" &&
          allowedStatusesForDocs.includes(getOrder?.status?.toLowerCase()) && (
          <UploadFile
            item={getOrder}
            onUpdateData={onForceUpdate}
            fetchOrderData={fetchOrderData}
          />
        )}
        <OrdersInfoCargo item={cargoDetails} order={getOrder} />
        <span className={style.orders_author}>
          <InfoIcon /> {getOrder?.author} {getOrder?.createdAtStr}
        </span>
      </div>
    </div>
    </TenderTimeProvider>
  );
};

export default OrderInfoMobile;
